<template>
  <div class="mt-2 form-responsive">
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data v-else :references.sync="formReferences" :model="modelObj" ref="ndtReference">
      <template v-if="modelObj.id && listOfDocuments.length > 0" slot="ndt_documents">
        <documents :documents="listOfDocuments" :deleteIds="deleteDocumentIds"></documents>
      </template>
    </form-data>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { hostAppApi } from '@/plugins/axios_settings'
import PermissionsMixin from '@/mixins/permissions'

export default {
  mixins: [PermissionsMixin],
  data () {
    return {
      listOfProjects: [],
      modelObj: {},
      loading: false,
      projectId: parseInt(this.$route.params.project_id) || 0,
      fieldsLoading: false,
      hostUserId: this.$cookie.get(process.env.VUE_APP_HOST_USER) ? this.$cookie.get(process.env.VUE_APP_HOST_USER) : 0,
      backUrl: '',
      listOfDocuments: [],
      deleteDocumentIds: [],
      hideDetails: true
    }
  },
  computed: {
    ...mapGetters(['formType', 'generalSettings', 'userDetails', 'getHostRefApi']),
    ...mapGetters('project', ['project']),
    formReferences () {
      /* Shared column map for the four report modules (Surface, Pressure test,
         Technical, NDT): phone (xs) / tablet portrait (sm) / tablet landscape (md) / desktop (lg) */
      const col = {
        heading: 'xs12',
        code: 'xs12 sm6 md4 lg3',
        wide: 'xs12',
        toggle: 'xs12 sm6 md4 lg3 toggle-col',
        files: 'xs12 sm12 md8 lg6'
      }
      const isNew = !this.modelObj.id

      return {
        cardFlat: true,
        cardTitleClass: 'pa-1',
        layoutClass: 'pa-1',
        title: isNew ? this.$t('message.common.addNew') : this.$t('message.common.update'),
        properties: [
          /* ---------------- Report details ---------------- */
          {
            type: 'section',
            label: this.$t('message.projects.sectionReportDetails'),
            class: col.heading
          }, {
            model: 'report_nr',
            type: this.formType.TEXT,
            rules: this.$_requiredValidation,
            label: this.$t('message.projectFeature.reportNumber'),
            class: col.code
          }, {
            model: 'operator',
            type: this.formType.TEXT,
            rules: this.$_requiredValidation,
            label: this.$t('message.projectFeature.operator'),
            class: col.code
          }, {
            model: 'po_ranked',
            type: this.formType.TEXT,
            readonly: true,
            label: this.$t('message.projectFeature.poRanked'),
            class: col.code
          },

          /* ---------------- Status and attachments ---------------- */
          {
            type: 'section',
            label: this.$t('message.projects.sectionStatusAttachments'),
            class: col.heading
          }, {
            model: 'is_completed',
            type: this.formType.CHECKBOX,
            rules: [],
            label: this.$t('message.customModule.isCompleted'),
            class: col.toggle
          }, {
            model: 'files',
            type: this.formType.FILES,
            multiple: true,
            rules: this.$_maxFileSizeValidation(100, this.modelObj.files),
            label: this.$t('message.projectFeature.uploadNdtDocument'),
            class: col.files,
            slot: 'ndt_documents'
          }
        ],
        buttons: [{
          name: 'save_ndt',
          color: 'primary',
          label: isNew ? this.$t('message.common.save') : this.$t('message.common.update'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'back',
          color: 'info',
          click: () => this.$router.go(-1),
          label: this.$t('message.login.back'),
          to: this.backUrl,
          is_show: true
        }]
      }
    }
  },
  mounted () {
    // set back url
    this.backUrl = this.projectId ? `/projects/${this.projectId}/ndt` : '/ndt'
    this.initializeFormData()
  },
  components: {
    'form-data': () => import('@/components/FormTemplate'),
    documents: () => import('@/components/Documents/Documents')
  },
  methods: {
    initializeFormData () {
      if (!this.project) return
      this.fieldsLoading = true
      this.modelObj = {
        po_ranked: this.project.number,
        project_id: this.projectId
      }
      if (this.$route.params.id) {
        this.initializeEditData(this.$route.params.id)
        return
      }
      this.fieldsLoading = false
    },
    getAllProjects () {
      this.$api.execute('get', 'projects/get_as_simplified_for_pwa?filter=2').then((response) => {
        this.listOfProjects = response.data
      })
    },
    saveUpdateHandler () {
      if (this.$refs.ndtReference.$refs.validateForm.validate()) {
        this.loading = true
        const files = this.modelObj.files
        const model = this.$formatter.cloneVariable(this.modelObj)
        model.user_id = parseInt(this.hostUserId)
        const formData = new FormData()
        if (files) {
          const Newfile = [...files]
          Newfile.forEach((file, i) => {
            formData.append('document[' + i + ']', file)
          })
        }
        const newobj = this.$formatter.removeInvalidFromObject(model)
        setTimeout(() => {
          for (const key in newobj) {
            if (key !== 'files') formData.append(key, key === 'is_completed' ? newobj[key] : newobj[key] || null)
          }
          const header = {
            'Content-Type': 'multipart/form-data'
          }
          let url = this.getHostRefApi
          // const method = model.id ? 'put' : 'post'
          url += model.id ? `project_ndt/${model.id}/update` : 'project_ndt'
          const text = model.id ? 'message.common.updatedSuccess' : 'message.common.addedSucess'
          /* on update check if there is documents in array to delete */
          const ids = [...this.deleteDocumentIds]
          if (model.id && ids.length > 0) formData.append('document_delete_ids', ids)
          hostAppApi.post(url, formData, { headers: header }) // `${url}?locale=${this.$i18n.locale}`
            .then((response) => {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
              this.$router.push(this.backUrl)
            })
            .finally(() => {
              this.loading = false
            })
        }, 50)
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.validationIssue' })
    },
    initializeEditData (id) {
      this.fieldsLoading = true
      hostAppApi.get(`${this.getHostRefApi}project_ndt/${id}/edit?user_id=${this.hostUserId}&project_id=${this.projectId}`)
        .then((response) => {
          if (response.data) {
            this.modelObj = {
              ...this.modelObj,
              ...response.data
            }
            this.listOfDocuments = this.$formatter.removeInvalidFromArrayObject(this.modelObj.documents)
          }
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    }
  },
  watch: {
    isShowDocumentErrors (val) {
      this.hideDetails = !val
    }
  }
}
</script>

<style>

</style>
